/* Zadaný vstup oddělí po trojicích s mezerou (= formátování čísel/telefonu) */
const formatNumber = (input: string | number | undefined) => {
    // ošetření na undefined/null, aby fungovalo pro nulu
    if (input === undefined || input === null) return '';

    const parts = input.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
};

export default formatNumber;
